/**
 * NIHARA LUXURY FASHION ??? MAIN WISHLIST V3 RENDER ENGINE
 * Single Source of Truth for rendering saved products as Version 3 cards in the Version 3 grid
 */
(function() {
  'use strict';

  /* 1. Universal Wishlist Harvester across all localStorage keys and formats */
  function harvestAllWishlistKeys() {
    var handles = [];
    function addKey(k) {
      if (k === null || k === undefined) return;
      var s = String(k).trim().replace(/^["'\[]+|["'\]]+$/g, '');
      if (s && s !== 'null' && s !== 'undefined' && !handles.includes(s)) {
        handles.push(s);
      }
    }

    var keys = ['nihara_wishlist', 'theme-wishlist', 'nihara_saved_items', 'wishlist', 'shopify_wishlist'];
    keys.forEach(function(storageKey) {
      try {
        var raw = localStorage.getItem(storageKey);
        if (!raw) return;
        try {
          var parsed = JSON.parse(raw);
          if (Array.isArray(parsed)) {
            parsed.forEach(function(item) {
              if (item && typeof item === 'object') {
                addKey(item.handle || item.id || item.product_id || item.variant_id);
              } else {
                addKey(item);
              }
            });
          } else if (parsed && typeof parsed === 'object') {
            Object.keys(parsed).forEach(function(k) { if (parsed[k]) addKey(k); });
          } else {
            addKey(parsed);
          }
        } catch(parseErr) {
          var splitItems = String(raw).split(/[,|\s]+/);
          splitItems.forEach(function(item) { addKey(item); });
        }
      } catch(e) {}
    });

    try {
      if (window.NiharaWishlistEngine && typeof window.NiharaWishlistEngine.getItems === 'function') {
        var items = window.NiharaWishlistEngine.getItems();
        (items || []).forEach(function(it) {
          if (it) addKey(it.handle || it.id);
        });
      }
    } catch(e) {}

    return handles;
  }

  /* 2. Extract embedded Liquid JSON store catalog */
  function getEmbeddedStoreCatalog() {
    var catalog = {};
    try {
      var catEl = document.getElementById('NiharaStoreProductsJson');
      if (catEl && catEl.textContent) {
        var list = JSON.parse(catEl.textContent);
        if (Array.isArray(list)) {
          list.forEach(function(p) {
            if (p) {
              if (p.id) catalog[String(p.id)] = p;
              if (p.handle) catalog[String(p.handle)] = p;
            }
          });
        }
      }
    } catch(e) {}
    return catalog;
  }

  /* 3. Main Render Function */
  function renderMainWishlistPage() {
    var mainContainer = document.getElementById('nih-wishlist-main-container');
    if (!mainContainer) return;

    var items = window.NiharaWishlistEngine ? window.NiharaWishlistEngine.getItems() : [];
    var allKeys = harvestAllWishlistKeys();
    var embeddedCatalog = getEmbeddedStoreCatalog();

    var toolbar = document.getElementById('nih-wishlist-toolbar');

    // If 0 saved items, show empty state
    if (allKeys.length === 0) {
      var countBadgeEmpty = document.getElementById('nih-wishlist-count-badge');
      if (countBadgeEmpty) countBadgeEmpty.textContent = '0 ITEMS SAVED';

      mainContainer.innerHTML = [
        '<div class="nih-wishlist-v3__empty" id="nih-wishlist-empty-state">',
          '<svg class="nih-wishlist-v3__empty-icon" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
          '<h2 class="nih-wishlist-v3__empty-title">Your wishlist is waiting.</h2>',
          '<p class="nih-wishlist-v3__empty-desc">Save the pieces you love and find them here whenever you\'re ready.</p>',
          '<a href="/collections/all" class="nih-wishlist-v3__empty-cta">Explore Collection +</a>',
        '</div>'
      ].join('');

      if (toolbar) toolbar.style.display = 'none';
      return;
    }

    if (toolbar) toolbar.style.display = 'flex';

    var sampleImgEl = document.querySelector('.mobile-card-v3__img--primary, img[src*="/products/"]');
    var defaultSampleImg = sampleImgEl ? sampleImgEl.getAttribute('src') : '';

    var grid = document.createElement('div');
    grid.className = 'mobile-grid-v3 nih-wishlist-v3__grid is-active';
    grid.style.setProperty('display', 'grid', 'important');

    var renderedIdentifiers = [];
    var uniqueProductCount = 0;

    allKeys.forEach(function(key) {
      var matchProduct = embeddedCatalog[key];
      if (!matchProduct) {
        matchProduct = (items || []).find(function(it) {
          return String(it.handle || it.id || '').trim() === key;
        });
      }

      var itemHandle = matchProduct ? String(matchProduct.handle || key).trim() : String(key).trim();
      var itemId = matchProduct ? String(matchProduct.id || key).trim() : String(key).trim();

      // DEDUPLICATION LOCK: Prevent rendering the exact same product multiple times if saved under both ID & Handle
      if (renderedIdentifiers.includes(itemHandle) || renderedIdentifiers.includes(itemId)) {
        return;
      }
      renderedIdentifiers.push(itemHandle);
      renderedIdentifiers.push(itemId);
      uniqueProductCount++;

      var itemTitle = matchProduct ? matchProduct.title : ('Nihara Product #' + key);
      var itemVendor = matchProduct ? (matchProduct.vendor || '') : '';
      var itemPrice = matchProduct ? matchProduct.price : '';
      var itemCompare = matchProduct ? matchProduct.compare_at_price : '';
      var itemUrl = matchProduct ? matchProduct.url : ('/products/' + key);
      var itemImg = (matchProduct && matchProduct.image) ? matchProduct.image : defaultSampleImg;
      var itemSecImg = (matchProduct && matchProduct.secondary_image) ? matchProduct.secondary_image : '';
      var itemSavings = matchProduct ? matchProduct.savings : 0;
      var itemTags = (matchProduct && Array.isArray(matchProduct.tags)) ? matchProduct.tags : [];
      var isNew = itemTags.some(function(t) { return String(t).toLowerCase() === 'new'; });

      var cardDiv = document.createElement('div');
      cardDiv.className = 'mobile-card-v3';
      cardDiv.setAttribute('data-product-handle', itemHandle);
      cardDiv.setAttribute('data-product-id', itemId);

      var badgesHtml = '';
      if (itemSavings > 0) {
        badgesHtml += '<span class="mobile-card-v3__badge mobile-card-v3__badge--sale">-' + itemSavings + '% OFF</span>';
      }
      if (isNew) {
        badgesHtml += '<span class="mobile-card-v3__badge">New In</span>';
      }

      var swipeDotsHtml = '';
      if (itemSecImg) {
        swipeDotsHtml = '<div class="mobile-card-v3__swipe-dots"><span class="mobile-card-v3__swipe-dot is-active"></span><span class="mobile-card-v3__swipe-dot"></span></div>';
      }

      var imageHtml = '';
      if (itemImg) {
        imageHtml += '<img src="' + itemImg + '" alt="' + itemTitle + '" class="mobile-card-v3__img mobile-card-v3__img--primary" loading="lazy" width="600" height="800">';
      } else {
        imageHtml += '<div class="mobile-card-v3__img" style="background:#f6f4f0;display:flex;align-items:center;justify-content:center;color:#888;">NIHARA</div>';
      }
      if (itemSecImg) {
        imageHtml += '<img src="' + itemSecImg + '" alt="' + itemTitle + '" class="mobile-card-v3__img mobile-card-v3__img--secondary" loading="lazy" width="600" height="800">';
      }

      cardDiv.innerHTML = [
        '<div class="mobile-card-v3__image-wrapper">',
          '<a href="' + itemUrl + '" class="mobile-card-v3__link" aria-label="View ' + itemTitle + '"></a>',
          (badgesHtml ? '<div class="mobile-card-v3__badges">' + badgesHtml + '</div>' : ''),
          '<button type="button" class="mobile-card-v3__wishlist is-active" ',
                  'data-wishlist-toggle="' + itemHandle + '" ',
                  'data-product-id="' + itemId + '" ',
                  'data-product-handle="' + itemHandle + '" ',
                  'data-product-title="' + itemTitle + '" ',
                  'data-product-price="' + itemPrice + '" ',
                  'data-product-url="' + itemUrl + '" ',
                  'aria-label="Remove from wishlist" ',
                  'onclick="if(window.NiharaWishlistToggle) window.NiharaWishlistToggle(event, this);">',
            '<svg viewBox="0 0 24 24"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>',
          '</button>',
          swipeDotsHtml,
          imageHtml,
        '</div>',
        '<div class="mobile-card-v3__info">',
          (itemVendor ? '<span class="mobile-card-v3__vendor">' + itemVendor + '</span>' : ''),
          '<h3 class="mobile-card-v3__title">' + itemTitle + '</h3>',
          '<div class="mobile-card-v3__price-row">',
            '<div class="mobile-card-v3__prices">',
              '<span class="mobile-card-v3__price">' + itemPrice + '</span>',
              (itemCompare ? '<span class="mobile-card-v3__price--compare">' + itemCompare + '</span>' : ''),
            '</div>',
            '<button type="button" class="mobile-card-v3__quick-add-btn" data-nihara-quick-add data-product-handle="' + itemHandle + '" aria-label="Quick add ' + itemTitle + '">',
              '<span>+ ADD</span>',
            '</button>',
          '</div>',
        '</div>'
      ].join('');

      grid.appendChild(cardDiv);
    });

    var countBadge = document.getElementById('nih-wishlist-count-badge');
    if (countBadge) {
      countBadge.textContent = uniqueProductCount + (uniqueProductCount === 1 ? ' ITEM SAVED' : ' ITEMS SAVED');
    }

    mainContainer.innerHTML = '';
    mainContainer.appendChild(grid);

    // Dynamic resolution fallback via store /products.json API
    fetch('/products.json?limit=250')
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(catalogData) {
        if (!catalogData || !Array.isArray(catalogData.products)) return;
        var catalogMap = {};
        catalogData.products.forEach(function(p) {
          if (p) {
            var pPrice = (p.variants && p.variants[0] && p.variants[0].price) ? parseFloat(p.variants[0].price) : 0;
            var pCompare = (p.variants && p.variants[0] && p.variants[0].compare_at_price) ? parseFloat(p.variants[0].compare_at_price) : 0;
            var itemObj = {
              id: String(p.id),
              handle: p.handle,
              title: p.title,
              vendor: p.vendor || '',
              price: pPrice ? ('Rs. ' + Math.round(pPrice).toLocaleString('en-IN')) : '',
              compare_at_price: (pCompare && pCompare > pPrice) ? ('Rs. ' + Math.round(pCompare).toLocaleString('en-IN')) : '',
              url: '/products/' + p.handle,
              image: (p.images && p.images[0]) ? p.images[0].src : (p.featured_image || ''),
              secondary_image: (p.images && p.images[1]) ? p.images[1].src : ''
            };
            catalogMap[String(p.id)] = itemObj;
            catalogMap[p.handle] = itemObj;
          }
        });

        // Update any missing card images/titles/secondary images
        allKeys.forEach(function(key) {
          var p = catalogMap[key];
          if (p) {
            var cardEl = mainContainer.querySelector('[data-product-handle="' + key + '"], [data-product-id="' + key + '"]');
            if (cardEl) {
              var titleEl = cardEl.querySelector('.mobile-card-v3__title');
              if (titleEl && p.title) titleEl.textContent = p.title;
              var priceEl = cardEl.querySelector('.mobile-card-v3__price');
              if (priceEl && p.price) priceEl.textContent = p.price;

              var wrapper = cardEl.querySelector('.mobile-card-v3__image-wrapper');
              if (wrapper) {
                var primImg = wrapper.querySelector('.mobile-card-v3__img--primary');
                if (primImg && p.image) {
                  primImg.setAttribute('src', p.image);
                } else if (!primImg && p.image) {
                  var newPrim = document.createElement('img');
                  newPrim.className = 'mobile-card-v3__img mobile-card-v3__img--primary';
                  newPrim.src = p.image;
                  newPrim.alt = p.title;
                  wrapper.appendChild(newPrim);
                }

                if (p.secondary_image) {
                  var secImg = wrapper.querySelector('.mobile-card-v3__img--secondary');
                  if (secImg) {
                    secImg.setAttribute('src', p.secondary_image);
                  } else {
                    var newSec = document.createElement('img');
                    newSec.className = 'mobile-card-v3__img mobile-card-v3__img--secondary';
                    newSec.src = p.secondary_image;
                    newSec.alt = p.title;
                    wrapper.appendChild(newSec);

                    if (!wrapper.querySelector('.mobile-card-v3__swipe-dots')) {
                      var dots = document.createElement('div');
                      dots.className = 'mobile-card-v3__swipe-dots';
                      dots.innerHTML = '<span class="mobile-card-v3__swipe-dot is-active"></span><span class="mobile-card-v3__swipe-dot"></span>';
                      wrapper.appendChild(dots);
                    }
                  }
                }
              }
            }
          }
        });
      }).catch(function() {});
  }

  // Clear Wishlist Listener
  document.addEventListener('click', function(e) {
    if (e.target && e.target.id === 'nih-wishlist-clear-btn') {
      e.preventDefault();
      if (confirm('Are you sure you want to clear your saved wishlist?')) {
        if (window.NiharaWishlistEngine && typeof window.NiharaWishlistEngine.save === 'function') {
          window.NiharaWishlistEngine.save([], [], 'cleared');
        } else {
          localStorage.removeItem('theme-wishlist');
          localStorage.removeItem('nihara_wishlist');
          localStorage.removeItem('nihara_saved_items');
          localStorage.removeItem('nihara_wishlist_items');
        }
        renderMainWishlistPage();
      }
    }
  });

  // Animated Wishlist Update Handler with Smooth Fade-Out
  function handleWishlistUpdateWithAnimation(e) {
    var mainContainer = document.getElementById('nih-wishlist-main-container');
    if (!mainContainer) {
      renderMainWishlistPage();
      return;
    }

    var allKeys = harvestAllWishlistKeys();
    var existingCards = mainContainer.querySelectorAll('.mobile-card-v3');
    var fadingCards = [];

    existingCards.forEach(function(card) {
      var cHandle = card.getAttribute('data-product-handle');
      var cId = card.getAttribute('data-product-id');
      if (cHandle || cId) {
        var isStillSaved = allKeys.includes(cHandle) || allKeys.includes(cId);
        if (!isStillSaved && !card.classList.contains('is-fading-out')) {
          card.classList.add('is-fading-out');
          fadingCards.push(card);
        }
      }
    });

    if (fadingCards.length > 0) {
      setTimeout(function() {
        renderMainWishlistPage();
      }, 350);
    } else {
      renderMainWishlistPage();
    }
  }

  // Global Wishlist Event Listeners
  document.addEventListener('nihara:wishlist:updated', handleWishlistUpdateWithAnimation);
  document.addEventListener('nihara:wishlist-updated', handleWishlistUpdateWithAnimation);
  document.addEventListener('wishlist:updated', handleWishlistUpdateWithAnimation);

  // Cross-tab Synchronization Listener
  window.addEventListener('storage', function(e) {
    if (e.key && e.key.includes('wishlist')) {
      handleWishlistUpdateWithAnimation();
    }
  });

  // Shopify Customizer Lifecycle Events
  ['shopify:section:load', 'shopify:section:select', 'shopify:section:reorder', 'shopify:section:deselect'].forEach(function(evt) {
    document.addEventListener(evt, renderMainWishlistPage);
  });

  // Initial and multi-tier timer backups for Theme Editor iframe latency
  renderMainWishlistPage();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderMainWishlistPage);
  }
  window.addEventListener('load', renderMainWishlistPage);

  [50, 200, 500, 1000, 2000, 3000].forEach(function(ms) {
    setTimeout(renderMainWishlistPage, ms);
  });

  // Expose global render function
  window.renderMainWishlistPage = renderMainWishlistPage;
})();

